<div class="cl-area-menu-scroller cl-layout-padding" id="viewAreaMenu">
    <cl-user-info *ngIf="emptyListCaption && isEmpty">
        {{ emptyListCaption }}
    </cl-user-info>
    <div *ngFor="let menuItem of items | keyvalue">
        <area-menu-item [item]="menuItem.value"></area-menu-item>
    </div>
</div>
